/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Branchen_Kennenlernen24Inputs */

const en__field_enum_tuda_branchen_kennenlernen24 = /** @type {(inputs: _Field_Enum_Tuda_Branchen_Kennenlernen24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get to know other industries`)
};

const de__field_enum_tuda_branchen_kennenlernen24 = /** @type {(inputs: _Field_Enum_Tuda_Branchen_Kennenlernen24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branchen und Tätigkeitsfelder kennenlernen`)
};

/**
* | output |
* | --- |
* | "Get to know other industries" |
*
* @param {_Field_Enum_Tuda_Branchen_Kennenlernen24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_branchen_kennenlernen24 = /** @type {((inputs?: _Field_Enum_Tuda_Branchen_Kennenlernen24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Branchen_Kennenlernen24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_branchen_kennenlernen24(inputs)
	return de__field_enum_tuda_branchen_kennenlernen24(inputs)
});
export { _field_enum_tuda_branchen_kennenlernen24 as "_field_enum_TUDA_BRANCHEN_KENNENLERNEN" }